var map = {
	"./destination-1.svg": "./src/assets/image/map-markers/destination-1.svg",
	"./destination-10.svg": "./src/assets/image/map-markers/destination-10.svg",
	"./destination-2.svg": "./src/assets/image/map-markers/destination-2.svg",
	"./destination-3.svg": "./src/assets/image/map-markers/destination-3.svg",
	"./destination-4.svg": "./src/assets/image/map-markers/destination-4.svg",
	"./destination-5.svg": "./src/assets/image/map-markers/destination-5.svg",
	"./destination-6.svg": "./src/assets/image/map-markers/destination-6.svg",
	"./destination-7.svg": "./src/assets/image/map-markers/destination-7.svg",
	"./destination-8.svg": "./src/assets/image/map-markers/destination-8.svg",
	"./destination-9.svg": "./src/assets/image/map-markers/destination-9.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/image/map-markers sync recursive ^\\.\\/destination\\-.*\\.svg$";